import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { ToasterService } from '../../shared/services/toaster.service';

export const errorHandlerInterceptor: HttpInterceptorFn = (req, next) => {
  const toasterService = inject(ToasterService);

  return next(req).pipe(
    catchError((err: HttpErrorResponse) => {
      const { message } = err?.error;
      toasterService.error(message || 'Something went wrong!');
      console.log('GLOBAL : ERROR => ', JSON.stringify(err.error), message);
      return throwError(() => err);
    }),
  );
};
